import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
import '../App.css';
import Navbar from './Navbar';
import Footer from './Footer';

const Home = () => {
  return (
    <>
      <div className='container'>
        <div
          className='jumbotron jumbotron-fluid'
          style={{
            backgroundColor: 'whitesmoke',
            border: '1px gray solid',
            marginTop: '5rem',
            padding: '3rem',
          }}
        >
<div className='container'>
            
<center><h2 className='bolder'>
           Programs begin Monday, June 28!<br/>
2021 Programs are running throughout the summer. Check out our catalog for availability.<br/><br/></h2>
  <h2 className='regular'>1st-12th+ graders everywhere are invited to join us. All are welcome! <br/>
         Space is limited so enroll soon! Tuition support is available. </h2><br/>
 <h2 className='bolder'>*All plans are subject to change. <br/></h2>
 <h2 className='bolder'>Please review our <br/>
 {<button className='btn btn-sm btn-info btn-link'><a href='https://docs.google.com/document/d/1dwxf5uG_DYpE7KqbCTf43RG9pnqlQI_ovB2ZjUax8Fw/edit?usp=sharing' target='blank' style={{textDecoration:'none'}}><span style={{color:'white'}}><h2 className='bolder'>Policies and Information</h2></span></a></button>}
 <h2 className='bolder'>carefully before enrolling.</h2>
</h2>
 
</center>
  
  
    </div>
        <div
          className='row'
          style={{ marginTop: '5rem', marginBottom: '5rem' }}
        >
          <div className='col-lg-3 col-md-6 col-sm-1 numbered-box'>
            <div class='box1'>
              <div class='number'>
                <h1>1</h1>
              </div>
              <br />
              <br />

              <div class='text'>
                <h2 className='bolder'>Search</h2>
              </div>
              <h2>
              Select the ‘View Programs’ button below and use the drop
              down menus at the top to filter your options.
              </h2>
            </div>
          </div>

          <div className='col-lg-3 col-md-6 col-sm-1 numbered-box'>
            <div class='box2'>
              <div class='number'>
                <h1>2</h1>
              </div>
              <br />
              <br />

              <div class='text'>
                <h2 className='bolder'>Register</h2>
              </div>
              <h2>
                Press the ‘register now’ link to enroll through our SawyerTools
                portal. If you do not yet have an account, you'll be asked to
                create one. Camps/Programs will stay in your cart for only 15
                minutes before checkout.
              </h2>
            </div>
          </div>

          <div className='col-lg-3 col-md-6 col-sm-1 numbered-box'>
            <div class='box3'>
              <div class='number'>
                <h1>3</h1>
              </div>
              <br />
              <br />

              <div class='text'>
                <h2 className='bolder'>Pay</h2>
              </div>
              <h2>
                A 10% non-refundable deposit is due at registration. The
                remaining balance may be paid in full or in 4 installments to be
                automatically billed to the card on file. Some programs may have
                additional materials fees.
              </h2>
            </div>
          </div>

          <div className='col-lg-3 col-md-6 col-sm-1 numbered-box'>
            <div class='box4'>
              <div class='number'>
                <h1 >4</h1>
              </div>
              <br />
              <br />

              <div class='text'>
                <h2 className='bolder'>Done</h2>
              </div>
              <h2>
                You will be contacted by the program chair with additional
                information as it becomes available.
              </h2>
            </div>
          </div>
        </div>

        <div
          className='row'
          style={{ marginTop: '5rem', marginBottom: '5rem' }}
        >
          <div className='col-sm-3'>
            <center>
              <Link
                to='catalog'
                className='btn btn-spaced'
                style={{
                  color: 'white',
                  backgroundColor: 'teal',
                  borderRadius: '20px',
                  width: '100%',
                  padding: '2.1rem',
                }}
              >
                <h2 className='bolder whiteText'>View Programs</h2>
              </Link>
            </center>
          </div>
          {<div className='col-sm-3'>
            <center>
              <a href='https://docs.google.com/document/d/19JHrtOyTkKQwnvs3ImXF-7qRujDq5D4SXC9t2I-zcrE/edit?usp=sharing' target='_blank'
                className='btn btn-spaced'
                style={{
                  color: 'white',
                  backgroundColor: 'teal',
                  borderRadius: '20px',
                  width: '100%',
                  padding: '2.1rem'
                }}
              >
                <h2 className='bolder whiteText'>Billing &amp; Payment</h2>
              </a>
            </center>
          </div>}
          <div className='col-sm-3'>
            <center>
              <a href='https://docs.google.com/document/d/14ch_rIpSePQFAyOOyAtAvBvzk-LSWfk3_BY2gDwY3_s/edit?usp=sharing' target='_blank'
                className='btn btn-spaced'
                style={{
                  color: 'white',
                  backgroundColor: 'teal',
                  borderRadius: '20px',
                  width: '100%',
                  padding: '2.1rem',
                }}

             >
                <h2 Contact className='bolder whiteText'>Contact Us</h2>
              </a>
            </center>
          </div>
          <div className='col-sm-3'>
            <center>
              <a href='https://docs.google.com/document/d/1dwxf5uG_DYpE7KqbCTf43RG9pnqlQI_ovB2ZjUax8Fw/edit?usp=sharing' target='_blank'
                className='btn btn-spaced'
                style={{
                  color: 'white!important',
                  backgroundColor: 'teal',
                  borderRadius: '20px',
                  width: '100%',
                  padding: '2.1rem',
                }}
              >
                  
                <h2 className='bolder whiteText'>Policies &amp; Information</h2>
              </a>
            </center>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Home;


